import { render, staticRenderFns } from "./CredenciamentoEsclarecimentoTabela.vue?vue&type=template&id=2fb44e28&scoped=true"
import script from "./CredenciamentoEsclarecimentoTabela.vue?vue&type=script&lang=js"
export * from "./CredenciamentoEsclarecimentoTabela.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoEsclarecimentoTabela.vue?vue&type=style&index=0&id=2fb44e28&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb44e28",
  null
  
)

export default component.exports